import React, { useState } from 'react';
import { Bell, Mail, MessageSquare, Smartphone } from 'lucide-react';

const NotificationSettings = ({ user }) => {
  const [settings, setSettings] = useState({
    email: {
      newTickets: true,
      statusUpdates: true,
      assignments: true,
      comments: false
    },
    push: {
      newTickets: true,
      statusUpdates: true,
      assignments: true,
      comments: true
    },
    sms: {
      newTickets: false,
      statusUpdates: false,
      assignments: true,
      comments: false
    }
  });

  const handleToggle = (channel, type) => {
    setSettings(prev => ({
      ...prev,
      [channel]: {
        ...prev[channel],
        [type]: !prev[channel][type]
      }
    }));
  };

  return (
    <div className="divide-y divide-gray-200">
      <div className="p-6">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
          <Bell className="w-5 h-5 text-gray-500" />
          Notification Preferences
        </h2>
      </div>

      <div className="p-6">
        <div className="space-y-6">
          {/* Email Notifications */}
          <div className="space-y-4">
            <h3 className="font-medium text-gray-900 flex items-center gap-2">
              <Mail className="w-5 h-5 text-gray-500" />
              Email Notifications
            </h3>
            <div className="space-y-3">
              {Object.entries(settings.email).map(([key, value]) => (
                <div key={key} className="flex items-center justify-between">
                  <span className="text-sm text-gray-700">
                    {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                  </span>
                  <button
                    onClick={() => handleToggle('email', key)}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full
                      ${value ? 'bg-blue-600' : 'bg-gray-200'}
                      transition-colors duration-200 ease-in-out`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform
                        ${value ? 'translate-x-6' : 'translate-x-1'}`}
                    />
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Push Notifications */}
          <div className="space-y-4">
            <h3 className="font-medium text-gray-900 flex items-center gap-2">
              <Smartphone className="w-5 h-5 text-gray-500" />
              Push Notifications
            </h3>
            <div className="space-y-3">
              {Object.entries(settings.push).map(([key, value]) => (
                <div key={key} className="flex items-center justify-between">
                  <span className="text-sm text-gray-700">
                    {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                  </span>
                  <button
                    onClick={() => handleToggle('push', key)}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full
                      ${value ? 'bg-blue-600' : 'bg-gray-200'}
                      transition-colors duration-200 ease-in-out`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform
                        ${value ? 'translate-x-6' : 'translate-x-1'}`}
                    />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationSettings; 